var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DashboardHeader',{attrs:{"title":"SMS Dashboard"}},[_c('BulkSMSComponent',{scopedSlots:_vm._u([{key:"SendSMS",fn:function(ref){
var recipientsObjArray = ref.recipientsObjArray;
return [_c('sendSMS',{staticClass:"mx-4",attrs:{"recipientsObjArray":recipientsObjArray}})]}},{key:"MembersList",fn:function(ref){
var selectedMembers = ref.selectedMembers;
var getSelectedMembers = ref.getSelectedMembers;
var openAddNewMemberDialog = ref.openAddNewMemberDialog;
return [_c('MembersList',{attrs:{"selectedMembers":selectedMembers},on:{"selected-members":getSelectedMembers,"open-add-new-member-dialog":openAddNewMemberDialog}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }